import React, { useState, useEffect } from 'react';
import JobCard from './JobCard';
import { jobs } from '../Data/jobs';
import '../styles/JobOpening.css';

const JobOpenings = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [filteredJobs, setFilteredJobs] = useState(jobs);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          if (entry.target.classList.contains('section-title')) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
          if (entry.target.classList.contains('job-card')) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.section-title, .job-card').forEach(el => {
      observer.observe(el);
      
      if (el.classList.contains('job-card')) {
        const index = Array.from(document.querySelectorAll('.job-card')).indexOf(el);
        el.style.transitionDelay = `${index * 0.1}s`;
      }
    });

    return () => observer.disconnect();
  }, [activeTab]);
   
  useEffect(() => {
    if (activeTab === 'all') {
      setFilteredJobs(jobs);
    } else {
      setFilteredJobs(jobs.filter(job => job.department === activeTab));
    }
  }, [activeTab]);

  const departments = [
    { id: 'all', name: 'All Positions' },
    { id: 'rnd', name: 'Research & Development' },
    { id: 'marketing', name: 'Marketing' },
    { id: 'operations', name: 'Operations' },
    { id: 'sales', name: 'Sales' }
  ];
  return (
    <section className="job-openings" id="openings">
      <div className="jobs-container">
        <div className="section-title">
          <h2>Current Job Openings</h2>
          <p>Explore opportunities to join our growing team in Maharashtra and beyond.</p>
        </div>
        
        <div className="job-tabs">
          {departments.map(dept => (
            <div 
              key={dept.id}
              className={`job-tab ${activeTab === dept.id ? 'active' : ''}`}
              onClick={() => setActiveTab(dept.id)}
            >
              {dept.name}
            </div>
          ))}
        </div>
        
        <div className="job-list">
          {filteredJobs.map((job, index) => (
            <JobCard key={index} job={job} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default JobOpenings;